import { render, staticRenderFns } from "./SingleBox.vue?vue&type=template&id=f8cf61c6&scoped=true"
import script from "./SingleBox.vue?vue&type=script&lang=js"
export * from "./SingleBox.vue?vue&type=script&lang=js"
import style0 from "./SingleBox.vue?vue&type=style&index=0&id=f8cf61c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cf61c6",
  null
  
)

export default component.exports